import {Injectable} from '@angular/core';

import {User} from "../../../classes/user";

@Injectable()
export class kanAuthService {
  private _user: User;
  private _token: string;
  private _refreshToken: string;
  private _remember: boolean;

  constructor() {
    this.remember = !!this.token;
  }

  set remember(remember: boolean) {
    this._remember = remember;
  }

  set token(token: string) {
    this._token = token;
    if (this._remember && this._token) {
      localStorage.setItem('kanToken', JSON.stringify(this._token));
    }
  }

  get token(): string {
    if (!this._token) {
      try {
        this._token = JSON.parse(localStorage.getItem('kanToken'));
      } catch (error){
        this._token = null;
      }
    }
    return this._token;
  }

  set refreshToken(refreshToken: string) {
    this._refreshToken = refreshToken;
    if (this._remember && this._refreshToken) {
      localStorage.setItem('kanRefreshToken', JSON.stringify(this._refreshToken));
    }
  }

  get refreshToken(): string {
    if (!this._refreshToken) {
      try {
        this._refreshToken = JSON.parse(localStorage.getItem('kanRefreshToken'));
      } catch (error){
        this._refreshToken = null;
      }
    }
    return this._refreshToken;
  }

  set user(user: User) {
    this._user = user;
    if (this._remember && this._user) {
      localStorage.setItem('kanUser', JSON.stringify(this._user));
    }
  }

  get user(): User {
    if (!this._user) {
      try {
        this._user = JSON.parse(localStorage.getItem('kanUser'));
      } catch (error) {
        console.log(error);
        this._user = null;
      }
    }
    return this._user;
  }

  get role(): string {
      return this.user ? this.user.role : null;
  }

  clear(): void {
    this._user = null;
    this._token = null;
    this._refreshToken = null;
    localStorage.removeItem('kanUser');
    localStorage.removeItem('kanToken');
    localStorage.removeItem('kanRefreshToken');
  }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/auth.ts